import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Founder Section - image zooms in, text fades from bottom
 */
export const animateFounderSection = (ref) => {
  if (ref.current) {
    const element = ref.current;
    const image = element.querySelector('img');
    const text = element.querySelector('[class*="founderText"]');
    
    // Set initial state immediately to prevent flash
    if (image) {
      gsap.set(image, { scale: 0.7, opacity: 0 });
    }
    if (text) {
      gsap.set(text, { opacity: 0, y: 50 });
    }
    
    const timer = setTimeout(() => {
      if (image) {
        gsap.to(image, {
          scale: 1,
          opacity: 1,
          duration: 1.3,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
      }
      
      if (text) {
        gsap.to(text, {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.4,
          ease: "power2.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
      }
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

